import { ailos } from "@/banks/ailos";
import { Banco, IGerarBoleto } from "./types/Boletos";
import { bradesco } from "@/banks/bradesco";
import { sicredi } from "@/banks/sicredi";
import { sicoob } from "@/banks/sicoob";
import { bancoBrasil } from "./banks/banco-brasil";

export function gerar({ banco, dados }: IGerarBoleto) {
  if (banco === Banco.AILOS) {
    return ailos.gerarDadosBoleto({ banco, dados });
  }

  if (banco === Banco.BRADESCO) {
    return bradesco.gerarDadosBoleto({ banco, dados });
  }

  if (banco === Banco.SICREDI) {
    return sicredi.gerarDadosBoleto({ banco, dados });
  }

  if (banco === Banco.SICOOB) {
    return sicoob.gerarDadosBoleto({ banco, dados });
  }

  if (banco === Banco.BANCO_BRASIL) {
    return bancoBrasil.gerarDadosBoleto({ banco, dados});
  }
}
